import { Api } from '@/api/api';
import { CreateAccessLogRequest } from '@/api/requests/access-logs/create-access-log-request';
import { CreateAccessLogResponse } from '@/api/responses/access-logs/create-access-log-response';

export class AccessLogApi extends Api {

    public async createAccessLog(request: CreateAccessLogRequest): Promise<CreateAccessLogResponse> {
        return await this.postAsync<CreateAccessLogResponse>(`v1/AccessLog`, request);
    }

    public async updateAccessLog(id: string | null, clientId: string | null | undefined): Promise<void> {
        if (id === null || clientId === null || clientId === undefined) {
            return;
        }
        return this.putAsync(`v1/AccessLog/${id}/client`, { clientId });
    }

    public constructor() {
        super();
    }
}
